<template>
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 50px">
    <div style="width: 100%;">
      <div class="page-title-container">
        <p class="title-container">
          SESSIONI
        </p>
      </div>
      <div class="table-container">
        <SessionsTable/>
      </div>
      <div
          id="form-position"
          class="form-container"
          v-if="this.store.state.sessioni.showContenutoSessioneState"
      >
        <ContenutoSessione
            v-if="this.store.state.sessioni.showContenutoSessioneState"
            :idSessioneSelected="this.store.state.sessioni.idSessioneSelezionato"
            :open="this.store.state.sessioni.showContenutoSessioneState"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {useStore} from 'vuex';
import Swal from "sweetalert2";

const axios = require('axios');
const {DateTime} = require("luxon");
import SessionsTable from '../components/SessionsTable.vue';
import ContenutoSessione from "@/components/ContenutoSessione.vue";

export default {
  name: "SessionsView",

  components: {
    ContenutoSessione,
    SessionsTable,
  },

  data() {
    return {}
  },

  setup() {
    const store = useStore();
    return {
      store,
      dateTime: DateTime,
    };
  },

  methods: {}
}
</script>

<style scoped>
.page-title-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-container {
  font-size: 2rem;
  letter-spacing: 2px;
}

.table-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  background-color: rgba(0, 0, 0, 0.25);
}

#form-position {
  position: absolute;
  z-index: 4 !important;
}

.v-btn--variant-outlined {
  border: thin solid #D0D0D0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}
</style>